import React from 'react';

const Segments = () => {
  return (
    <div className="content-header">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Segments</h1>
      <div className="box box-primary">
        <div className="box-header with-border">
          <h3 className="box-title">Segments Analysis</h3>
        </div>
        <div className="box-body">
          <p className="text-gray-700">Segments content will be displayed here</p>
        </div>
      </div>
    </div>
  );
};

export default Segments;

